import { memo } from 'react';
import { cn } from '../../utils/cn';

interface KanbanPriorityBadgeProps {
  priority: number;
  className?: string;
}

const getPriorityStyle = (p: number): string => {
  if (p <= 2) return 'bg-red-500/15 text-red-300 border-red-500/25';
  if (p <= 4) return 'bg-orange-500/15 text-orange-300 border-orange-500/25';
  if (p <= 6) return 'bg-yellow-500/15 text-yellow-300 border-yellow-500/25';
  if (p <= 8) return 'bg-green-500/15 text-green-300 border-green-500/25';
  return 'bg-blue-500/15 text-blue-300 border-blue-500/25';
};

export const KanbanPriorityBadge = memo(({ priority, className }: KanbanPriorityBadgeProps) => (
  <span
    className={cn(
      'inline-flex items-center badge border',
      getPriorityStyle(priority),
      className,
    )}
  >
    P{priority}
  </span>
));
KanbanPriorityBadge.displayName = 'KanbanPriorityBadge';
